module.exports = __webpack_public_path__ + "img/2.50a87a43.jpeg";